import { z } from "zod";

export const UserSettingsSchema = z.object({
  theme: z.enum(["DARK", "LIGHT"]).default("LIGHT"),
  language: z.union([z.literal("en-US"), z.literal("pt-BR")]).default("pt-BR"),
  financialsTable: z
    .object({
      textAlignment: z
        .union([z.literal("LEFT"), z.literal("CENTER"), z.literal("RIGHT")])
        .describe("The text alignment of the table cells"),
      sortDirection: z.union([z.literal("ASC"), z.literal("DESC")]).describe("The sort direction of the table"),
      fullBleed: z.boolean().describe("Always show the table with full width"),
    })
    .default({
      sortDirection: "ASC",
      textAlignment: "CENTER",
      fullBleed: false,
    }),
  hasClosedMarch24PerpetualBlackPopUp: z
    .boolean()
    .default(false)
    .describe("Determines if the User has closed the one-off March '24 Black popup"),
});

export type UserSettingsShape = z.infer<typeof UserSettingsSchema>;
export type UserSettingsOptionsKeys = keyof UserSettingsShape;
